import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const FairlyImportantIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-fairlyImportant"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M48,0 L46,0 C44.3427153,0 43,1.34271525 43,3 L43,31 C43,32.6572847 44.3427153,34 46,34 L48,34 C49.6572847,34 51,32.6572847 51,31 L51,3 C51,1.34271525 49.6572847,0 48,0 Z M46,2 L48,2 C48.5527153,2 49,2.44728475 49,3 L49,31 C49,31.5527153 48.5527153,32 48,32 L46,32 C45.4472847,32 45,31.5527153 45,31 L45,3 C45,2.44728475 45.4472847,2 46,2 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M35,33 L33,33 C31.895,33 31,32.105 31,31 L31,13 C31,11.895 31.895,11 33,11 L35,11 C36.105,11 37,11.895 37,13 L37,31 C37,32.105 36.105,33 35,33"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M35,10 L33,10 C31.3427153,10 30,11.3427153 30,13 L30,31 C30,32.6572847 31.3427153,34 33,34 L35,34 C36.6572847,34 38,32.6572847 38,31 L38,13 C38,11.3427153 36.6572847,10 35,10 Z M33,12 L35,12 C35.5527153,12 36,12.4472847 36,13 L36,31 C36,31.5527153 35.5527153,32 35,32 L33,32 C32.4472847,32 32,31.5527153 32,31 L32,13 C32,12.4472847 32.4472847,12 33,12 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
        />
        <path
          d="M22,33 L20,33 C18.895,33 18,32.105 18,31 L18,23 C18,21.895 18.895,21 20,21 L22,21 C23.105,21 24,21.895 24,23 L24,31 C24,32.105 23.105,33 22,33"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M22,20 L20,20 C18.3427153,20 17,21.3427153 17,23 L17,31 C17,32.6572847 18.3427153,34 20,34 L22,34 C23.6572847,34 25,32.6572847 25,31 L25,23 C25,21.3427153 23.6572847,20 22,20 Z M20,22 L22,22 C22.5527153,22 23,22.4472847 23,23 L23,31 C23,31.5527153 22.5527153,32 22,32 L20,32 C19.4472847,32 19,31.5527153 19,31 L19,23 C19,22.4472847 19.4472847,22 20,22 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
